import { z } from 'zod';

export const inviteUserSchema = z.object({
  email: z.string().email('Must be a valid email address'),
  name: z.string().min(1, 'Name is required'),
  role: z.enum(['platform_admin', 'company_admin', 'facilitator', 'executive']),
  companyId: z.string().min(1, 'Company is required'),
});

export const createUserSchema = z.object({
  email: z.string().email('Must be a valid email address'),
  password: z
    .string()
    .min(8, 'Password must be at least 8 characters')
    .regex(/[a-z]/, 'Password must contain a lowercase letter')
    .regex(/[A-Z]/, 'Password must contain an uppercase letter')
    .regex(/[0-9]/, 'Password must contain a number')
    .regex(/[^A-Za-z0-9]/, 'Password must contain a special character'),
  companyId: z.string().min(1, 'Company is required'),
});

export type InviteUserFormValues = z.infer<typeof inviteUserSchema>;
export type CreateUserFormValues = z.infer<typeof createUserSchema>;
